import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Tools.module.scss';

export const ToolsStepTwo = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.toolsLeftSection}>
        <span className={styles.toolsStepLeft_1}>TransparenTerra’s</span>
        <span className={styles.toolsStepLeft_2}>Tools</span>
        <span className={styles.toolsStepLeft_3}>and</span>
        <span className={styles.toolsStepLeft_4}>principles</span>
      </div>
    }
    rightContent={
      <div className={styles.toolsStepContentWrapper}>
        <p style={{ marginBottom: 40 }}>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>An ESG score calculator</div>
          The ESG score calculator shows how well company&apos;s activities align with the ESG
          principles. TransparenTerra specialists developed this calculator alongside leading ESG
          experts.
        </p>
        <p>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>
            Environmental footprint calculators
          </div>
          Footprint calculators calculate your company&apos;s environmental footprint based on data
          you provide. Once you have your company’s ESG score, you’ll get preliminary advice on how
          to mitigate your environmental impact and a list of sustainability experts you can turn to
          for professional consulting.
        </p>
      </div>
    }
  />
);
